import { createTermTagManager } from '../../utils/createTermTagManager';

export const wheelchairAccessibleTagManager = createTermTagManager({
  jsonQueryKey: 'wheelchair_accessible',
  label: 'Доступно для людей на колясках',
  id: 'wheelchairAccessible',
});
